// extracted by mini-css-extract-plugin
export default {"pageHeader":"styles_pageHeader__iAzXH"};